// import nathan_treska from '../../../assets/img/partnerPortal/welcomeDXC/nathan-treska.jpg';
// import luis_porem from '../../../assets/img/partnerPortal/welcomeDXC/luis-porem.png';
// import arnab_sub from '../../../assets/img/partnerPortal/welcomeDXC/arnab_sub.jpg';
// import krishna_devulapalli from '../../../assets/img/partnerPortal/welcomeDXC/krishna-devulapalli.png';
// import matt_kay from '../../../assets/img/partnerPortal/welcomeDXC/matt-kay.png';
// import tushar_patwardhan from '../../../assets/img/partnerPortal/welcomeDXC/tushar-patwardhan.png';
// import alejandro_musgrove from '../../../assets/img/partnerPortal/welcomePage/alejandro-musgrove.jpg';
// import alex_lim from '../../../assets/img/partnerPortal/welcomePage/alex-lim.png';
import custom from "../../../assets/img/partnerPortal/welcomePage/innovate.png";
import gartner_banner from "../../../assets/img/partnerPortal/welcomePage/gartner_banner.png";
import perform_banner from "../../../assets/img/partnerPortal/welcomePage/perform_banner.jpg";

import News from "../../../models/common/News";
import Contact from "../../../models/common/Contact";
import Item from "../../../models/common/Item";
import Banner from "../../../models/common/Banner";

// BANNER
export const TITLE = (
  <div>
    Welcome to your<br></br>Partner Portal
  </div>
);
export const ABOVE_TITLE = "PREMIER PARTNER";
export const BUTTON_NAME = "Register a deal";
export const BUTTON_LINK = "https://partners.dynatrace.com/#/page/sales";
// --

// BANNERS
const banner0: Banner = new Banner(
  "https://www.dynatrace.com/gartner-magic-quadrant-for-observability-platforms/?utm_med[…]race&utm_campaign=partner&utm_content=portal&utm_term=q2fy25",
  "_parent",
  "100%",
  gartner_banner
);
const banner1: Banner = new Banner(
  "https://partners.dynatrace.com/#/page/perform-2025-on-demand",
  "_parent",
  "100%",
  perform_banner
);

export const ALL_BANNERS: Array<Banner> = new Array<Banner>(banner0, banner1);

// CONTACTS

const dynaContact1: Contact = new Contact(
  "Nathan Treska",
  "Global Director, DXC Alliance",
  "nathan.treska@dynatrace.com",
  "Tel. +1 858-344-6406"
);
const dynaContact2: Contact = new Contact(
  "Luis Porem",
  "VP, EMEA Partners",
  "luis.porem@dynatrace.com",
  "Tel. +351 965-060-497"
);
const dynaContact4: Contact = new Contact(
  "Alejandro Musgrove",
  "Senior Director LATAM Partners",
  "alejandro.musgrove@dynatrace.com",
  "Tel. +1 954-684-3117"
);
const dynaContact5: Contact = new Contact(
  "Alex Lim",
  "Senior Director APAC Partners",
  "alex.lim@dynatrace.com",
  "Tel. +65 833-959-68"
);
export const ALL_DYNA_CONTACT_LIST: Array<Contact> = new Array<Contact>(
  dynaContact1,
  dynaContact2,
  dynaContact4,
  dynaContact5
);

const partnerContact1: Contact = new Contact(
  "Arnab Sur",
  "Global Alliance Leader",
  "asur3@dxc.com",
  "Tel. +1 408-410-7905"
);
const partnerContact2: Contact = new Contact(
  "Krishna Devulapalli",
  "Global Offering Lead",
  "kdevulapalli@dxc.com",
  "Tel. +1 302-235-9371"
);
const partnerContact3: Contact = new Contact(
  "Matt Kay",
  "Global Product Manager",
  "mkay4@dxc.com",
  "Tel.+44 777-197-5265"
);
const partnerContact4: Contact = new Contact(
  "Tushar Patwardhan",
  "Global Delivery Leader APM",
  "tushar.patwardhan@dxc.com",
  "Tel. +1 972-897-3580"
);
export const ALL_PARTNER_CONTACT_LIST: Array<Contact> = new Array<Contact>(
  partnerContact1,
  partnerContact2,
  partnerContact3,
  partnerContact4
);
// --

// NEWS AND EVENTS
const news33: News = new News(
  "Perform and Innovate Sponsor Prospectus FY26",
  "https://partners.dynatrace.com/content/8a99822b95b0e7e80195b4734ee018f8",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news32: News = new News(
  "Watch Perform on-demand​",
  "https://www.dynatrace.com/perform/",
  true,
  true,
  true,
  undefined,
  "Watch now"
);
const news31: News = new News(
  "Dynatrace Introduces Observability for Developers​",
  "https://www.dynatrace.com/news/press-release/dynatrace-introduces-observability-for-developers/",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news30: News = new News(
  "Dynatrace Partners with Visa Cash App Racing Bulls (VCARB) Formula One™ Team​",
  "https://www.dynatrace.com/news/press-release/dynatrace-partners-with-visa-cash-app-racing-bulls-vcarb-formula-one-team-as-official-observability-performance-analytics-technology-partner/",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news29: News = new News(
  "Streaming event: Dynatrace & the Power of Possible​",
  " https://webinars.techstronglearning.com/dynatrace-and-the-power-of-possible?utm_medium=partner&utm_source=dynatrace&utm_campaign=virtual-event&utm_content=portal&utm_term=q3fy25",
  false,
  true,
  true
);
const news28: News = new News(
  "Partners lead with Dynatrace SaaS​",
  "https://partners.dynatrace.com/#/collateral/8a9983ce90d6f9a50190f221a5f121bd",
  false,
  true,
  true
);
const news26: News = new News(
  "Dynatrace named a Leader in the 2024 Gartner® Magic Quadrant™ for Observability Platforms​",
  "https://www.dynatrace.com/gartner-magic-quadrant-for-observability-platforms/?utm_medium=partner&utm_source=dynatrace&utm_campaign=partner&utm_content=portal&utm_term=q2fy25",
  false,
  true,
  true
);

// const event17: News = new News("Dynatrace Perform is back in Vegas 3-5 Feb 2025", "https://www.dynatrace.com/perform/?utm_medium=partner&utm_source=dynatrace&utm_campaign=event&utm_content=portal&utm_term=q2fy25", false, true, true, undefined, "Register now");
const event17: News = new News(
  "Learn how to master the Dynatrace Partner Deliver Toolkit",
  "https://info.dynatrace.com/noram-all-wb-partner-delivery-toolkit-26404-od-fulfillment.html?utm_medium=partner&utm_source=dynatrace&utm_campaign=portal&utm_content=all-active-partners&utm_term=none&mkt_tok=MzUyLU5WTy01NjIAAAGY5uZvOiRelPaOTN3vSicEXtUu1G4fcCPHd0QPVHj8YbfjrjGTV3GCMjiUFZaQKdEbZlgiU3boBximTOnaZiQb",
  true,
  true,
  true,
  "On-Demand Webinar",
  "Watch now"
);
const event13: News = new News(
  "Key highlights from Perform 2025",
  "https://partners.dynatrace.com/#/page/perform-2025-on-demand",
  true,
  true,
  true,
  "On-Demand Webinar",
  "Watch now"
);

//const event11: News = new News("Amplify partner enablement PowerUP", "https://www.dynatrace.com/amplify/ ", false, false, false, "On-Demand Webinar", "Watch now");
//const news4: News = new News("Dynatrace announces GTM partnership with Microsoft", "https://www.dynatrace.com/news/press-release/dynatrace-announces-expanded-commitment-gtm-partnership-microsoft/", false, false, false, "Dynatrace news");
//const news6: News = new News("Dynatrace expands Davis to deliver first hypermodal AI ", "https://www.dynatrace.com/news/press-release/dynatrace-expanding-davis-hypermodal-ai/", false, false, false, "Dynatrace news");
//const news7: News = new News("Dynatrace ranked #1 in 6 of 6 Use Cases in 2023 Gartner® Critical Capabilities for APM and Observability report", "https://www.dynatrace.com/gartner-critical-capabilities-for-application-performance-monitoring-observability/", false, false, false, "Dynatrace news");
//const news9: News = new News("Dynatrace named a Leader in the 2023 Gartner MQ for APM & Observability", "https://www.dynatrace.com/monitoring/gartner-magic-quadrant-for-application-performance-monitoring-observability/", false, false, false, "Dynatrace news");
//const news5: News = new News("How to Register a Deal in the Dynatrace Partner Portal", "https://partners.dynatrace.com/#/collateral/8a998afb881bdd180188248f1e5d32dc", false, false, false, "How to?");
//const event1: News = new News("Dynatrace Application Security Achieves", "https://www.dynatrace.com/news/press-release/dynatrace-appsec-achieves-fedramp-stateramp/", false, false, false, "Dynatrace news");
//const event3: News = new News("Opinion: Efficiency, automation, and integration key to partners’ success", "https://www.computerweekly.com/microscope/opinion/Efficiency-automation-and-integration-key-to-partners-success", false, false, false, "Dynatrace news");
//const event4: News = new News("Dynatrace and Snyk Unify Security Insights Across the Entire Software Lifecycle", "https://www.dynatrace.com/news/press-release/dynatrace-and-snyk-to-unify-security-insights/", false, false, false, "Dynatrace news");
//const event5: News = new News("Dynatrace Delivers Real-Time Insights into the Carbon Footprint of Hybrid and Multicloud Ecosystems", "https://www.dynatrace.com/news/press-release/dynatrace-carbon-impact-app/", false, false, false, "Dynatrace news");
//const event6: News = new News("Cloud Architect Webinar", "https://info.dynatrace.com/global-all-wc-cloud-architect-webinar-20396-registration.html?_ga=2.2546352.1036965896.1683821194-2063192864.1683821194", true, false, false, "On-Demand Webinar");
export const ALL_EVENTS_LIST: Array<News> = new Array<News>(
  news33,
  news32,
  news31,
  news30,
  news29,
  news28,
  news26,
  event17,
  event13
);

// ITEMS
const item1: Item = new Item(
  "Ausgrid meets stringent requirements for real-time meter reading and reporting with DXC, Dynatrace, and ServiceNow",
  "View PDF",
  "https://partners.dynatrace.com/#/collateral/8a9983cf8e1b6d3a018e1e0b444c54de"
);
const item2: Item = new Item(
  "DXC & Dynatrace win at CIBC",
  "View PDF",
  "https://partners.dynatrace.com/#/collateral/8a998a608e12e37a018e19511a7b123d"
);
const item3: Item = new Item(
  "DXC and Dynatrace win at Cenovus Energy",
  "View PDF",
  "https://partners.dynatrace.com/#/collateral/8a998a608e12e37a018e1e0b52f761bc"
);
export const ALL_ITEMS_LIST: Array<Item> = new Array<Item>(item1, item2, item3);

// TOOLS
const tool1: Item = new Item(
  "Quick Reference Guide - CloudOps Automation",
  "View PDF",
  "https://partners.dynatrace.com/#/collateral/8a998a608e12e37a018e1dd0280e31ee"
);
const tool2: Item = new Item(
  "Quick Reference Guide - Intelligent Observability",
  "View PDF",
  "https://partners.dynatrace.com/#/collateral/8a9983cf8e1b6d3a018e1dd0089a2480"
);
const tool3: Item = new Item(
  "Quick Reference Guide - DXC and Dynatrace Joint Elevator pitch",
  "View PDF",
  "https://partners.dynatrace.com/#/collateral/8a9983cf8e1b6d3a018e1e0b368454d0"
);
const tool5: Item = new Item(
  "City of Milan: Brief insight into how Dynatrace has been integrated into DXC’s Cloud DevOps Platform (CDP)",
  "View PDF",
  "https://info.dynatrace.com/global_all_rm_dxc_dynatrace_city_of_milan_case_study_16164_registration.html?_ga=2.51884969.1030809402.1684143380-1127633402.1684143380"
);
const tool6: Item = new Item(
  "DXC Technology Service Automation Demo: Explore how you can shift your IT spend from locked-in apps maintenance costs to invest in business innovations and digital strategies",
  "View video",
  "https://www.youtube.com/watch?v=AofvmfbSVpY"
);
export const ALL_TOOLS_LIST: Array<Item> = new Array<Item>(
  tool1,
  tool2,
  tool3,
  tool5,
  tool6
);
